import React from 'react';
import ServicesMenu from './ServicesMenu';
import {Link, withRouter} from 'react-router-dom';
import {
  Collapse,
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Container,
} from 'reactstrap';
import { useInView } from 'react-intersection-observer';

import FadeInAnimation from '../home_page/homeComponents/FadeInAnimation';
import { NAV_IMAGES } from '../../../../assets/images/landing';

import {
  NavBarContainer,
  PublicNavWave,
  NavBarContainer2,
  LoginButton,
  SignUpButton,
  DashboardButton,
  NavBarImage,
} from './navbarStyle';
import { ROUTES } from '../../routes';

const NavbarLoggedOut = (props) => {
  const [ref, inView] = useInView({
    triggerOnce: true
  });

  if (props.nonAppPage){
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {props.nonAppPage && !props.disableWaveBackground && <PublicNavWave aria-hidden="true" />}
      <div style={{ position: 'relative', zIndex: 20 }}>
      <FadeInAnimation
        duration={0.4}
        yOffset={-20}
        inView={inView}
      >
        <NavBarContainer disableWaveBackground={true} className="website-navigation">
          <Container>
            <Navbar color='transparent' light expand='md' id={props.removeNavbar ? "navbarNoOptions" : ""}>
              <Link to="/" className="navbar-brand">
                <NavBarImage src={NAV_IMAGES.WebLogo} alt='' />
              </Link>
              {props.removeNavbar ? null : <Collapse navbar>
                <div className="desktop-navigation"><Nav className="nav-links" id={props.navbarHideMiddleButtons ? "hiddenMiddleButtons" : ""}navbar>
                  <ServicesMenu />
                  {!props.navbarHideMiddleButtons &&
                    <NavItem>
                      <NavLink tag={Link} to={ROUTES.ABOUT}>About Us</NavLink>
                    </NavItem>}
                  {!props.navbarHideMiddleButtons &&
                  <NavItem>
                    <NavLink tag={Link} to={ROUTES.BLOG_INDEX}>Blog</NavLink>
                  </NavItem>}
                  {!props.navbarHideMiddleButtons &&
                  <NavItem>
                    <NavLink tag={Link} to={ROUTES.LOCATIONS}>Coverage</NavLink>
                  </NavItem>}
                  {!props.navbarHideMiddleButtons &&
                  <NavItem>
                    <NavLink tag={Link} to={ROUTES.CAREERS}>Careers</NavLink>
                  </NavItem>}
                  {!props.navbarHideMiddleButtons &&
                  <NavItem>
                    <NavLink tag={Link} to={ROUTES.CONTACTS}>Contact</NavLink>
                    {/* <NavLink href={ROUTES.CONTACTS}>Contact</NavLink> */}
                  </NavItem>}
                  </Nav><Nav className="nav-actions" navbar>{props.navbarHideMiddleButtons ? "" : props.currentUser ? <NavItem>
                    <Link to={ROUTES.DASHBOARD}>
                      <DashboardButton>Dashboard</DashboardButton>
                    </Link>
                  </NavItem> : <NavItem className="nav-login">
                    <Link to={ROUTES.LOGIN} className="loggedInNAv">
                      <LoginButton>Log In</LoginButton>
                    </Link>
                  </NavItem>
                  }
                    {props.currentUser ? "" : <NavItem className="high-z-index">
                    <div
                       onClick={() => props.setModal(true)}>
                      <SignUpButton>Schedule Shoot</SignUpButton>
                    </div>
                  </NavItem>
                 }
                </Nav></div>

              </Collapse>
             }
            </Navbar>
          </Container>
        </NavBarContainer>
      </FadeInAnimation>
      </div>
    </div>
  );
   } else{
    return (
      <div ref={ref} style={{ position: 'relative' }}>
        <div style={{ position: 'relative', zIndex: 20 }}>
        <FadeInAnimation
          duration={0.4}
          yOffset={-20}
          inView={inView}
        >
          <NavBarContainer2 className="website-navigation">
            <Container>
              <Navbar color='transparent' light expand='md'>
                <Link to="/" className="navbar-brand">
                  <NavBarImage src={NAV_IMAGES.WebLogo} alt='' />
                </Link>
                <Collapse navbar>
                  <div className="desktop-navigation"><Nav className="nav-links" navbar>
                    <ServicesMenu />
                    <NavItem>
                      <NavLink tag={Link} to={ROUTES.ABOUT}>About Us</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink tag={Link} to={ROUTES.BLOG_INDEX}>Blog</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink tag={Link} to={ROUTES.CAREERS}>Careers</NavLink>
                    </NavItem>
                    {/* <NavItem>
                    <NavLink href='#'>Case Studies</NavLink>
                  </NavItem> */}
                    <NavItem>
                      <NavLink tag={Link} to={ROUTES.CONTACTS}>Contact</NavLink>
                      {/* <NavLink href={ROUTES.CONTACTS}>Contact</NavLink> */}
                    </NavItem>
                    </Nav><Nav className="nav-actions" navbar>{props.currentUser ? <NavItem>
                      <Link to={ROUTES.DASHBOARD}>
                        <DashboardButton>Dashboard</DashboardButton>
                      </Link>
                    </NavItem> : <NavItem className="nav-login">
                      <Link to={ROUTES.LOGIN} className="loggedInNAv">
                        <LoginButton>Log In</LoginButton>
                      </Link>
                    </NavItem>
                    }
                    {props.currentUser ? "" : <NavItem className="high-z-index">
                      <div
                        onClick={() => props.setModal(true)}>
                        <SignUpButton>Schedule Shoot</SignUpButton>
                      </div>
                    </NavItem>
                    }
                  </Nav></div>

                </Collapse>
              </Navbar>
            </Container>
          </NavBarContainer2>
        </FadeInAnimation>
      </div>
      </div>
    );
    }
};

export default withRouter(NavbarLoggedOut);
